export enum RevioAccount {
  TELCLOUD = 'telcloud',
  TBCRESELLER = 'tbcreseller',
}
